<template>
  <div class="wxButton">
<!--    <div>{{ wxConfig.signature }}</div>-->
<!--    <div>{{ encryptCode }}</div>-->
    <!-- <div contenteditable="true">{{ itemList }}</div> -->
    <van-button @click="chooseWxInvoice">选择微信发票</van-button>
<!--    <van-button @click="resetKey">返回值</van-button>-->
  </div>
</template>

<script>
var wx = require('weixin-js-sdk');
import Cookies from "js-cookie";

export default {
  created() {
    this.qywxConfig();
  },
  data() {
    return {
      wxConfig: {
        appId: "",
        timestamp: "",
        nonceStr: "",
        signature: "1"
      },
      ssss1: window.location.href.split('#')[0],
      cardId: 'id',
      encryptCode: '',
      itemList: ''
    };
  },
  methods: {
    qywxConfig: function () {
      let self = this
      this.$api.post("/payment/center/hoau/tencent/wxConfig", {
        reqData: {
          url: this.ssss1
        },
      }).then((res) => {
        if (res.repCode === "0000") {
          this.wxConfig = res.repData
          console.log(res.repData)
          wx.config({
            beta: true,// 必须这么写，否则wx.invoke调用形式的jsapi会有问题
            // debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.repData.appId, // 必填，企业微信的corpID
            timestamp: res.repData.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.repData.nonceStr, // 必填，生成签名的随机串
            signature: res.repData.signature,// 必填，签名，见附录1
            jsApiList: ['chooseInvoice'], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          });
          wx.ready(function () {
            // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
            console.log("签名成功");
            self.encryptCode = '5555555'
          });
        }
      });
    },
    chooseWxInvoice() {
      let self = this
      this.$api.post("/payment/center/hoau/tencent/wxInvoke", {
        reqData: {},
      }).then((res) => {
        if (res.repCode === "0000") {
          this.wxChoose = res.repData;
          console.log(res.repData.cardSign)
          wx.invoke('chooseInvoice', {
            'timestamp': res.repData.timestamp, // 卡券签名时间戳
            'nonceStr': res.repData.nonceStr, // 卡券签名随机串
            'signType': res.repData.signType, // 签名方式，默认'SHA1'
            'cardSign': res.repData.cardSign, // 卡券签名
          }, function (res) {
            // 这里是回调函数
            console.log(JSON.stringify(res));
            Cookies.set("chooseInvoiceKey", res)
            self.encryptCode = JSON.stringify(res);
            if (0 === res.err_code) {
              self.getInvoiceBatch(res.choose_invoice_info)
            }
          });
        }
      });
    },
    getInvoiceBatch(list) {
      this.$api.post("/payment/center/hoau/tencent/wxInvoiceInfoBatch", {
        reqData: {'itemList': JSON.parse(list)}
      }).then((res) => {
        if (res.repCode === "0000") {
          this.itemList = JSON.stringify(res.repData)
          if(res.repData && res.repData.length){
            this.$api.post("/payment/center/invoiceClip/invoiceSwitch",{
              reqData:{
                itemList:res.repData
              }
            }).then(res2=>{
              if(res2.repCode === "0000"){
                this.$emit("change",res2.repData)
              }
            })
          }
        }
      });
    },
    resetKey() {
      this.encryptCode = Cookies.get("chooseInvoiceKey")
    }
  }
}
</script>

<style lang="scss">
  .wxButton{
    display: flex;
    button{
      width: 100%;
    }
  }
</style>